import { render } from "./02_Boutiques.vue?vue&type=template&id=f0bccd3c&scoped=true"
import script from "./02_Boutiques.vue?vue&type=script&lang=js"
export * from "./02_Boutiques.vue?vue&type=script&lang=js"

import "./02_Boutiques.vue?vue&type=style&index=0&id=f0bccd3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0bccd3c"]])

export default __exports__